import * as _ from 'lodash';
import { IEwtSummary, ITargetItem } from '@nkr/models/index';
import { MatchRunType } from '@nkr/enums/index';
import { ListType } from '@nkr/views/target-new/list-type';
import { Button, FormControl, InputGroup, Panel, Radio, Well } from 'react-bootstrap';
import { ConfigWrapper } from './styles';
import Targets from './targets';
import { useState } from 'react';

interface IProps {
    data: {
        matchRunType: number,
        maxChainDepth: number,
        maxLoopDepth: number,
        veryLowPmp: number,
        lowPmp: number,
        hlaFloorForAccumulator: number,
        bufferDonorAgeByYears: number,
        bufferHlaMatchPointsByPoints: number,
        onlyOToO: boolean,
        ignoreBlockAllDonors: boolean,
        returnOnlyOBDs: boolean
    },
    targets: ITargetItem[],
    targetListType: ListType,
    onChange: (property: string, value: any) => void,
    onShowEwt: (ewtSummary: IEwtSummary, initialCount: any) => void,
    onShowMortalityBreakdown: (type: number, recipient: ITargetItem) => void
}

const Config = (props: IProps) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (e: React.ChangeEvent<any>) => {
        props.onChange(e.currentTarget.name, e.currentTarget.value);
    };

    let { matchRunType, maxChainDepth, maxLoopDepth, onlyOToO, returnOnlyOBDs } = props.data;

    let maxChainDepthList = _.range(1, 11);
    let maxLoopDepthList = _.range(1, 16);
    
    let booleanList = [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
    ];

    return (
        <Panel style={{ marginBottom: 5 }} expanded={expanded}>
            <Panel.Heading>
                <Button bsSize='sm' onClick={() => setExpanded(!expanded)}>Settings</Button>
            </Panel.Heading>
            <Panel.Collapse>
                <Panel.Body>
                    <ConfigWrapper style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td>
                                    {matchRunType == MatchRunType.Chains ?
                                        <InputGroup bsSize='sm'>
                                            <InputGroup.Addon>Max Chain Depth:</InputGroup.Addon>
                                            <FormControl
                                                componentClass='select'
                                                bsSize='sm'
                                                name='maxChainDepth'
                                                value={maxChainDepth}
                                                onChange={handleChange}
                                            >
                                                {maxChainDepthList.map((item, index) =>
                                                    <option key={'max-chain-depth-' + index} value={item}>{item}</option>
                                                )}
                                            </FormControl>
                                        </InputGroup>
                                        :
                                        <InputGroup bsSize='sm'>
                                            <InputGroup.Addon>Max Loop Depth:</InputGroup.Addon>
                                            <FormControl
                                                componentClass='select'
                                                bsSize='sm'
                                                name='maxLoopDepth'
                                                value={maxLoopDepth}
                                                onChange={handleChange}
                                            >
                                                {maxLoopDepthList.map((item, index) =>
                                                    <option key={'max-loop-depth-' + index} value={item}>{item}</option>
                                                )}
                                            </FormControl>
                                        </InputGroup>
                                    }
                                </td>
                                <td>
                                    <InputGroup bsSize='sm'>
                                        <InputGroup.Addon>Only 'O' to 'O':</InputGroup.Addon>
                                        {booleanList.map((item, index) =>
                                            <InputGroup.Addon key={'only-o-to-o-' + index} style={{ backgroundColor: 'white' }}>
                                                <Radio name='onlyOToO' id={'onlyOToO' + item.text} inline checked={onlyOToO == item.value} value={item.value.toString()} onClick={handleChange}>
                                                    {item.text}
                                                </Radio>
                                            </InputGroup.Addon>
                                        )}
                                    </InputGroup>
                                </td>
                                <td>
                                    <InputGroup bsSize='sm'>
                                        <InputGroup.Addon>Return Only 'O' Paired Donors:</InputGroup.Addon>
                                        {booleanList.map((item, index) =>
                                            <InputGroup.Addon key={'return-only-o-paired-donors-' + index} style={{ backgroundColor: 'white' }}>
                                                <Radio name='returnOnlyOBDs' id={'returnOnlyOBDs' + item.text} inline checked={returnOnlyOBDs == item.value} value={item.value.toString()} onClick={handleChange}>
                                                    {item.text}
                                                </Radio>
                                            </InputGroup.Addon>
                                        )}
                                    </InputGroup>
                                </td>
                            </tr>
                        </tbody>
                    </ConfigWrapper>

                    {props.targetListType != null && props.targets.length > 0 && (
                        <Targets
                            list={props.targets}
                            type={props.targetListType}
                            onShowEwt={props.onShowEwt}
                            onShowMortalityBreakdown={props.onShowMortalityBreakdown}
                        />
                    )}
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    );
}

export default Config;